/**
 * Index arithmetic for the preview's lead pager.
 *
 * Pulled out of the component because the interesting part is the wrap, and the
 * wrap is exactly what a naive `(i + delta) % total` gets wrong: JavaScript's %
 * keeps the sign, so stepping back from 0 yields -1, and `roster[-1]` is
 * undefined — the preview would blank instead of landing on the last lead.
 * Adding `total` before the second modulo is what makes it a ring.
 */

/** Next index after moving `delta` from `current`, wrapping at both ends. */
export function stepIndex(current: number, delta: number, total: number): number {
  if (!Number.isFinite(total) || total <= 0) return 0
  return (((current + delta) % total) + total) % total
}

/**
 * Clamp a possibly-stale index into a roster that may have shrunk (the campaign
 * changed underneath the editor). Never returns an out-of-range index.
 */
export function safeIndex(current: number, total: number): number {
  if (!Number.isFinite(total) || total <= 0) return 0
  return ((current % total) + total) % total
}
